$(() => {
	$(document).on('click', '[data-relatedmagazinesaction]', function (e) {
		e.preventDefault();

		const url = $(this).data('relatedmagazinesaction');
		const container = $('.related-magazines-content');

		$.ajax({
			url: url,
			type: 'GET',
			dataType: 'html',
			success: function (response) {
				const $response = $(response);

				container.html($response.filter('.related-magazines-content').html());

				container.siblings('.pagination-margin').remove();
				$response.filter('.pagination-margin').insertAfter(container);

				const navbarHeight = $('#navbar').outerHeight() || 0;
				$('html, body').animate({scrollTop: $('#related-magazines').offset().top - navbarHeight - 20}, 500);
			},
		});
	});
});
